import cookie from 'js-cookie';

export const getCookie = cname => cookie.get(cname);

export const removeCookie = key => {
  if (typeof window !== 'undefined') {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

export const setCookie = (key, value, expires) => {
  if (typeof window !== 'undefined') {
    cookie.set(key, value, {
      expires,
      path: '/',
    });
  }
};
